import React from "react";
import { Link } from "react-router-dom";
import { useGuildPath } from "../../utils/Guild/useGuild";
import { openCookiePreferences } from "../../utils/Tracking/consent";

// Home-page footer: the genre page footer (page-sink) laid out horizontally.
// Same N background and gradient, but the links sit on one line with the legal
// line beneath, and the social icons fill the space on the right.
export default function FooterHome() {
  const guildPath = useGuildPath();

  return (
    <div
      className="page-sink footer-home"
      style={{
        backgroundImage:
          "linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(135, 0, 20, 1) 100%)",
      }}
    >
      <div className="page-sink-background" aria-hidden={"true"} />
      <div className="width-ctrl">
        {/* Grid on desktop so the social column spans all three rows; the DOM
            order here is the mobile stacking order. */}
        <div className="footer-home-inner">
          <div className="page-identity footer-home-identity">
            <Link to={guildPath("/")} className="">
              <img
                src="/img/netflix-logo-ribbon.png"
                alt="NF"
                className="page-logo"
              />
            </Link>
            <Link to={guildPath("/")} className="page-identity-copy">
              <div className="page-identity-title">Series</div>
              <div className="page-identity-subtitle d-none d-sm-block">
                For Your Consideration
              </div>
              <div className="page-identity-subtitle d-block d-sm-none">
                FYC
              </div>
            </Link>
          </div>

          <div className="page-sink-nav footer-home-links">
            <Link to={guildPath("/")}>Home</Link>
            <Link to={"/events"}>Events</Link>
            <Link to={"/privacy-and-terms"}>Privacy and Terms</Link>
            <Link to={"/do-not-sell-or-share"}>
              Do Not Sell or Share My Personal Information
            </Link>
            <Link to={"mailto:fysee@netflix.com"} target={"_blank"}>
              fysee@netflix.com
            </Link>
            <a
              href="#cookie-preferences"
              onClick={(e) => {
                e.preventDefault();
                openCookiePreferences();
              }}
            >
              Cookie Preferences
            </a>
          </div>

          <div className="page-sink-social footer-home-social">
            <div>
              <a
                href="https://www.instagram.com/netflix"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={"/img/ico/ig.png"} alt={"Instagram"} />
              </a>
            </div>
            <div>
              <a
                href="https://www.facebook.com/netflix"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={"/img/ico/fb.png"} alt={"Facebook"} />
              </a>
            </div>
          </div>

          <div className="page-sink-legal footer-home-legal">
            All uses of the Netflix For Your Consideration Website are subject
            to the terms of use associated with your promotional code and the{" "}
            <Link to="/privacy-and-terms">Privacy and Terms</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
